import { createFileRoute } from "@tanstack/react-router";

import { LogoutScreen } from "@/interactors/LogoutScreen";

export const Route = createFileRoute("/_authed/student/logout/")({
  component: LogoutScreen,
});
